var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16.5,
    viewBox: "0 0 22 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4612",
    "data-name": "Path 4612",
    d: "M8.938-16.5A2.063,2.063,0,0,1,11-14.437a2.064,2.064,0,0,1-.825,1.65L.825-5.775a1.379,1.379,0,0,1-1.65,0l-9.35-7.013A2.065,2.065,0,0,1-11-14.437,2.062,2.062,0,0,1-8.938-16.5ZM-1.65-4.675a2.746,2.746,0,0,0,3.3,0L11-11.687V-2.75A2.753,2.753,0,0,1,8.25,0H-8.25A2.751,2.751,0,0,1-11-2.75v-8.937Z",
    transform: "translate(11 16.5)",
    fill: "#A2A2A2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGray);
export default __webpack_public_path__ + "static/media/email-gray.12a5e3d9849b30ad36d7da4c126a1292.svg";
export { ForwardRef as ReactComponent };